import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import React, { AllHTMLAttributes, useMemo } from 'react';

import { ANIMATED_TEXT_ANIMATION } from './AnimatedText.animations';

import S from './AnimatedText.module.scss';

import { fonts } from 'styles/fontsRegistry';

export interface AnimatedTextProps extends AllHTMLAttributes<HTMLDivElement> {
  words?: string[];
  wordsSaid: string[];
}

const AnimatedText: React.FC<AnimatedTextProps> = ({
  words,
  wordsSaid,
  className,
}) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const id = useMemo(() => new Date().toLocaleString(), [words]);
  const INVISIBLE_TEXTS = ['<break', 'time="', '/>'];
  const isTextVisible = (word: string): boolean => {
    // Returns false if any of the INVISIBLE_TEXTS are present in the word
    return !INVISIBLE_TEXTS.some(invisibleText => word.includes(invisibleText));
  };

  return (
    <div className={clsx(S.AnimatedTextWrapper, className)}>
      <AnimatePresence>
        {words && (
          <motion.div
            className={clsx(S.AnimatedText)}
            {...ANIMATED_TEXT_ANIMATION}
            key={id}
          >
            {words.map((word, index) => {
              const isVisible = isTextVisible(word);
              const opacityValue = isVisible ? (wordsSaid[index] ? 1 : 0.5) : 0;
              const widthValue = isVisible ? 'auto' : 0;
              const heightValue = isVisible ? 'auto' : 0;

              return (
                <span
                  key={`animated_${word}_${index}`}
                  style={{
                    display: 'inline-block',
                    border: '2px solid transparent',
                    width: widthValue,
                    height: heightValue,
                    opacity: opacityValue,
                  }}
                  className={clsx(fonts.paragraph2, S.Word)}
                >
                  {`${word} `}
                </span>
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AnimatedText;
